<template>
    <div class="appeal">
        <date-picker :date.sync="query.billDate" type="year-month" title="选择年月" />
        <lazy-load-list :getData="initData" :description="'暂无支付记录'" :query="query">
            <template v-slot="slotData">
                <div class="appeal-list">
                    <div class="flex align-center" v-for="(item, index) in slotData.dataList" :key="index">
                        <div class="appeal-radio">
                            <van-checkbox checked-color="#009af3" v-if="item.orderCode == choseOrder.orderCode" @click="radioChange(item)" :value="true"></van-checkbox>
                            <van-checkbox checked-color="#009af3" v-else @click="radioChange(item)" :value="false"></van-checkbox>
                        </div>
                        <div class="appeal-list-item">
                            <div class="parkingPay-carInfo-content">
                                <div class="carInfo-content-item flex align-center">
                                    <img class="carInfo-content-item1" src="@/assets/images/pay/parking-time.png" alt="" />
                                    <p class="carInfo-content-item-title">订单类型</p>
                                    <p class="carInfo-content-item-value">
                                        <span v-if="item.orderType == 1">余额充值</span>
                                        <span v-else-if="item.orderType == 2">路内停车缴费</span>
                                        <span v-else-if="item.orderType == 3">预约缴费</span>
                                        <span v-else-if="item.orderType == 4">预约超时缴费</span>
                                        <span v-else-if="item.orderType == 5">停车预缴</span>
                                        <span v-else-if="item.orderType == 6">路外停车缴费</span>
                                        <span v-else-if="item.orderType == 7">会员升级费用</span>
                                        <span v-else-if="item.orderType == 8">月卡购买</span>
                                    </p>
                                </div>
                                <div v-if="item.payTime" class="carInfo-content-item flex align-center">
                                    <img class="carInfo-content-item1" src="@/assets/images/pay/parking-time.png" alt="" />
                                    <p class="carInfo-content-item-title">支付时间</p>
                                    <p class="carInfo-content-item-value">{{ item.payTime }}</p>
                                </div>

                                <div v-if="item.orderCode" class="carInfo-content-item flex align-center">
                                    <img class="carInfo-content-item1" src="@/assets/images/pay/parking-time.png" alt="" />
                                    <p class="carInfo-content-item-title">订单号</p>
                                    <p class="carInfo-content-item-value">{{ item.orderCode }}</p>
                                </div>

                                <div v-if="item.stallCode" class="carInfo-content-item flex align-center">
                                    <img class="carInfo-content-item1" src="@/assets/images/pay/parkingPay-number.png" alt="" />
                                    <p class="carInfo-content-item-title">泊位号</p>
                                    <p class="carInfo-content-item-value">{{ item.stallCode }}</p>
                                </div>
                                <div v-if="item.plateNum" class="carInfo-content-item flex align-center">
                                    <img class="carInfo-content-item1" src="@/assets/images/pay/parkingPay-code.png" alt="" />
                                    <p class="carInfo-content-item-title">车牌号</p>
                                    <p class="carInfo-content-item-value">{{ item.plateNum }}</p>
                                </div>
                            </div>
                            <div class="appeal-item-header flex align-center justify-between">
                                <p class="appeal-item-site"></p>
                                <p class="appeal-item-payMoney">￥{{ item.orderMoney }}</p>
                            </div>
                            <!-- <div class="appeal-item-bottom flex align-center justify-between">
                                <p class="appeal-item-site"></p>
                                <p>已优惠：{{ item.couponMoney }}</p>
                            </div> -->
                        </div>
                    </div>
                </div>
            </template>
        </lazy-load-list>
        <!-- 订单申诉弹窗 -->
        <dialog-slot :isTitle="true" :show.sync="show" leftBtnText="提交申诉" @handleLeftBtn="submitAppeal">
            <template v-slot:title> 订单申诉 </template>
            <template v-slot:content>
                <div class="dialog-container">
                    <div class="dialog-bottom">
                        <div class="dialog-bottom-title">申诉原因</div>
                        <van-field class="textarea" v-model="appealReason" rows="3" autosize type="textarea" maxlength="200" placeholder="请输入200字以内的申诉原因。" />
                    </div>
                </div>
            </template>
        </dialog-slot>

        <div class="guide-button">
            <van-button type="info" @click="appeal" class="button">
                <template #default>
                    <div class="guide-item flex align-center">
                        <p style="color: #fff">进行申诉</p>
                    </div>
                </template>
            </van-button>
        </div>

        <Dialog :show.sync="showDialog" @hideDialog="showDialog = false" @handleLeftBtn="hideDialog" @handleConfirm="handleConfirm" leftBtnText="查看详情" rightBtnText="确认" content="已成功提交投诉建议" />
    </div>
</template>

<script>
import { listMyBill, orderAppeal } from "@/api/api";
import DialogSlot from "@/components/base/dialogSlot/dialog-slot.vue";
import Dialog from "@/components/base/dialog/dialog.vue";
import { one2two, secondToMinute } from "@/libs/tools";
import DatePicker from "@/components/base/datePicker/date-picker.vue";
import LazyLoadList from "@/components/base/lazyLoadList/lazy-load-list.vue";

import { Toast } from "vant";
export default {
    name: "orderAppeal",
    components: {
        DialogSlot,
        Dialog,
        DatePicker,
        LazyLoadList,
    },
    data() {
        return {
            showDatePick: false,
            appealReason: "",

            choseOrder: {}, //选中的订单

            checkNum: "",
            show: false,
            showDialog: false,
            query: {
                billDate: "2021-10",
                pageNum: 0,
                pageSize: 10,
                orderType: "",
            },
        };
    },
    mounted() {},
    methods: {
        secondToMinute,
        //给子组件使用
        initData() {
            return listMyBill(this.query);
        },

        //提交申诉
        submitAppeal() {
            let query = {
                appealContent: this.appealReason, //申诉内容
                // parkType: this.choseOrder.type ? this.choseOrder.type : null, //停车记录类型 1：路内 2：路外
                // parkingRecordId: this.choseOrder.parkingRecordId ? this.choseOrder.parkingRecordId : null, //停车记录id
                orderCode: this.choseOrder.orderCode, //订单id
            };
            orderAppeal(query).then((res) => {
                if (res.code == 200) {
                    this.show = false;
                    this.id = res.data;
                    this.showDialog = true;
                }
            });
        },
        // 订单申诉关闭弹窗
        hideDialogSlot() {
            this.show = false;
            this.appealReason = "";
        },
        //查看详情
        hideDialog() {
            this.showDialog = false;
            this.$router.push({
                query: { type: 1, id: this.id },
                name: "orderAppealDetail",
            });
        },
        //确认
        handleConfirm() {
            this.showDialog = false;
        },
        // 进行申诉
        appeal() {
            if (!this.choseOrder.orderCode) {
                Toast({
                    message: "请选择单号",
                });
                return;
            }
            this.show = true;
        },
        //选择id
        radioChange(item) {
            if (this.choseOrder.orderCode == item.orderCode) {
                this.choseOrder = {};
                return;
            }
            this.choseOrder = item;
        },
    },
};
</script>

<style lang="less" scoped>
@import "~@/assets/style/color.less";
.invoice-header {
    width: 750px;
    height: 90px;
    padding: 30px;
    position: fixed;
    top: 0;
    left: 0;
    background-color: #fff;
    z-index: 99;
    p .invoice-date {
        font-size: 28px;
        color: #666666;

        i {
            margin: 0 4px;
        }
    }
    .invoice-header-cancle {
        margin-left: 30px;
        img {
            width: 32px;
            height: 32px;
            margin-right: 15px;
        }
    }
    .invoice-header-batch {
        margin-left: 30px;
        color: @main-color;
        img {
            width: 32px;
            height: 32px;
            margin-right: 15px;
        }
    }
}
.appeal {
    width: 100%;
    .appeal-list {
        margin-top: 100px;

        .appeal-radio {
            margin-right: 20px;
        }
        padding: 16px 24px;
        .appeal-list-item {
            width: 702px;
            border-radius: 16px;
            background-color: #fff;
            margin-bottom: 16px;

            .appeal-item-header {
                width: 100%;
                height: 73px;
                padding: 0 30px;
                border-top: 1px solid #dbdada;
                .appeal-item-site {
                    font-size: 30px;
                    color: #333333;
                }
                .appeal-item-payMoney {
                    color: #009af3;
                    font-size: 36px;
                }
                .appeal-item-status {
                    font-size: 30px;
                }
                .color-gray {
                    color: #999;
                }
                .color-red {
                    color: #f96161;
                }
            }

            .appeal-item-bottom {
                width: 100%;
                padding: 0 30px 10px 30px;
                color: #999999;
                .appeal-item-site {
                    font-size: 30px;
                    color: #333333;
                }
            }

            .parkingPay-carInfo-content {
                // flex: 1;
                padding: 24px 20px 27px;

                .carInfo-content-header {
                    font-size: 32px;
                    font-weight: 500;
                    color: #212121;
                    margin-bottom: 30px;
                }

                .carInfo-content-item {
                    margin-bottom: 16px;

                    .carInfo-content-item1 {
                        width: 24px;
                        height: 24px;
                    }

                    .carInfo-content-item2 {
                        width: 24px;
                        height: 28px;
                    }

                    .carInfo-content-item-title {
                        margin-left: 17px;
                        vertical-align: top;
                    }

                    .carInfo-content-item-value {
                        margin-left: auto;
                        color: #666666;
                    }
                }
            }
            .appeal-item-pay {
                padding: 0 30px 30px;
                text-align: right;
                .appeal-item-pay-btn {
                    width: 160px;
                    height: 48px;
                    white-space: nowrap;
                }
            }
        }
    }
}
.guide-button {
    display: flex;
    justify-content: space-around;
    align-items: center;
    position: fixed;
    bottom: 0;
    height: 120px;
    width: 100%;
    background-color: #fff;

    .button {
        width: 90%;
        border-radius: 20px;
        background-image: linear-gradient(90deg, #009af3 0%, #00c6ea 100%);
    }
}

.guide-item {
    div {
        width: 32px;
        height: 32px;
    }

    img {
        width: 32px;
        height: 32px;
    }
    p {
        font-size: 28px;
        color: #333333;
        margin-left: 17px;
    }
}
.dialog-container {
    .dialog-bottom {
        padding: 0 32px;
        .dialog-bottom-title {
            margin: 20px 0;
            font-size: 28px;
        }
        .textarea {
            margin: 20px 0;
            background-color: #f5f5f5;
        }
    }
}

.line {
    width: 90%;
    margin: 0 auto;
    border-bottom: 0.5px #dbdada solid;
}
</style>
